import { useQuery } from "@tanstack/react-query";
import { trendsForecast } from "../api/trendsForecast";
import { TrendsGraphData } from "../types";

export const useTrendsForecast = () => {

    const { data, isLoading, isError, error, isSuccess } = useQuery({
        queryKey: ["trends-forecast"],
        queryFn: () => trendsForecast.fetch(),
    });

    return {
        data: isSuccess ? data : {} as TrendsGraphData,
        isLoading,
        isError,
        error,
        isSuccess,
    };

};
